import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=3c01af3d&"
import script from "./Paper.vue?vue&type=script&lang=ts&"
export * from "./Paper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports